export enum AppName {
    RTL = 'rtlhr',
    NET = 'nethr',
    ZENA = 'zenahr',
    ALL = 'all'
}

export type StrictAppNames = Exclude<AppName, AppName.ALL>
